import {takeEvery} from 'redux-saga/effects'
import {GET_LOGS} from 'setup/redux/Actions/DatabaseLog/components/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  // Category
  yield takeEvery(GET_LOGS, fetchData)
}

export default dataSaga
